import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Bell } from "lucide-react";
import { api, shortDate } from "../lib/api";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const SEV = { critical: "#F87171", warning: "#FFB800", info: "#37E5D7" };

export const NotificationBell = () => {
  const [d, setD] = useState({ unread: 0, items: [] });
  const [open, setOpen] = useState(false);
  const seen = useRef(null);
  const load = useCallback(async () => {
    const { data } = await api.get("/notifications");
    if (seen.current) data.items.filter((n) => n.created_at > seen.current).slice(0, 3).forEach((n) => toast(n.title, { description: n.body }));
    if (data.items[0]) seen.current = data.items[0].created_at;
    else if (!seen.current) seen.current = new Date().toISOString();
    setD(data);
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [load]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="relative text-white/60 hover:text-white transition-colors" data-testid="notification-bell">
          <Bell className="w-4 h-4" />
          {d.unread > 0 && <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 bg-[#FF2BD6] text-black text-[9px] font-bold font-mono flex items-center justify-center" data-testid="notification-count">{d.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-96 p-0 bg-black/95 backdrop-blur-xl border-white/15" data-testid="notification-panel">
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <span className="label-xs">Alerts · in-app · slack · email (mocked)</span>
          <button onClick={() => api.post("/notifications/read-all").then(load)} className="font-mono text-[10px] text-white/50 hover:text-brand" data-testid="notifications-read-all">mark all read</button>
        </div>
        <ul className="max-h-96 overflow-y-auto">
          {d.items.length === 0 && <li className="p-4 text-xs text-white/40">No alerts yet.</li>}
          {d.items.map((n) => (
            <li key={n.id} className={`px-4 py-3 border-b border-white/5 ${n.read ? "opacity-60" : ""}`} data-testid={`notification-${n.id}`}>
              <div className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full" style={{ background: SEV[n.severity] }} />
                <span className="text-sm text-white">{n.link ? <Link to={n.link.startsWith("/app") ? n.link : `/app${n.link}`} className="hover:text-brand" onClick={() => setOpen(false)}>{n.title}</Link> : n.title}</span></div>
              <p className="text-xs text-white/55 mt-1">{n.body}</p>
              <p className="font-mono text-[9px] text-white/30 mt-1">{shortDate(n.created_at)} · {n.channels.join(" · ")}</p>
            </li>
          ))}
        </ul>
      </PopoverContent>
    </Popover>
  );
};
